import ApiModel from "./ApiModel";
import ApiAuth from "../api/public/system/ApiAuth";

// Модель для защищённых эндпоинтов: Bearer-заголовок + авто-refresh по 401.
// ВСЕ admin-модели наследуют этот класс, а не ApiModel.
export default class ApiModelWithAuth extends ApiModel {
    __isRetriedAuth = false; // флаг «уже ретраил» — повтор строго один раз

    getHeaders() {
        const headers = {
            'Accept': 'application/json',
            'Authorization': `Bearer ${this.getAccessToken()}`,
        };
        // Для FormData браузер сам ставит Content-Type с boundary
        if (!this.isSendFile) headers['Content-Type'] = 'application/json';
        return headers;
    }

    async _query(path, method, data, type) {
        let answer = await super._query(path, method, data, type);
        if (answer.code !== 401) return answer;
        if (this.__isRetriedAuth) {
            await ApiAuth.Logout();
            return answer;
        }
        this.__isRetriedAuth = true;
        // Единый in-flight Promise внутри RefreshToken — параллельные 401 не сожгут ротацию
        const isRefreshed = await ApiAuth.RefreshToken();
        if (!isRefreshed) return answer;
        answer = await super._query(path, method, data, type);
        if (answer.code === 401) await ApiAuth.Logout();
        return answer;
    }
}
